import * as d3 from 'd3'
import clone from 'lodash/clone'
import map from 'lodash/map'
import filter from 'lodash/filter'
import includes from 'lodash/includes'
import findLastIndex from 'lodash/findLastIndex'

const util = {}

// TODO    ideally, return deep clones?
/**
 * Finds hits in data2 not contained in data1
 * @param data1 previous array of hits
 * @param data2 new array of hits
 * @returns {*} array of hits
 */
util.diff = function (data1, data2) {
    let delta
    let idsData1

    if (data1 === null || data1 === undefined) {
        return data2
    }

    idsData1 = map(data1, 'playId')

    delta = filter(data2, (d) => !includes(idsData1, d.playId))

    return delta
}
let savedLPR

/**
 * Returns null when state='Final' or no rounds
 * @param flatRounds
 * @param derbyData
 * @returns {*}
 */
// note: relies on flatRounds sorted chronologically
util.livePlayerRound = function (flatRounds, derbyData) {
    const lastHrTimes = flatRounds.map((round) =>
        d3.max(round.hits, (d) => d.time)
    )
    const lastHrTime = d3.max(lastHrTimes)
    const lastHrIndex = lastHrTimes.findIndex((d) => d === lastHrTime)

    const i = findLastIndex(
        flatRounds,
        (r) => r.hits.length > 0 && r.complete !== true
    )
    const likelyBetweenRounds = i === -1 && flatRounds.length
    let lastRound = likelyBetweenRounds
        ? flatRounds[lastHrIndex]
        : flatRounds[i]

    // /// IF COMPLETE IS NULL (-1) select who ever is last
    // if (i === -1) {
    //     i = _.findLastIndex(flatRounds, function (r) {
    //         return r.hits.length > 0
    //     });
    //     lastRound = flatRounds[i];
    // }
    // else {
    //     lastRound = flatRounds[i];
    // }

    // if (derbyData.status.state === 'Final' || !flatRounds || flatRounds.length === 0) {
    // if (!flatRounds || flatRounds.length === 0 || lastRound === null) {
    if (!flatRounds || flatRounds.length === 0) {
        return null
    }

    if (lastRound === undefined || lastRound === null) {
        lastRound = savedLPR
    } else {
        savedLPR = lastRound
    }

    return new PlayerRound(lastRound)
}

function PlayerRound(data) {
    this.playerId = data ? data.playerId : null
    this.complete = data ? data.complete : null
    this.playerName = data ? data.playerName : null
    this.round = data ? data.round : null
    this.roundType = data ? data.roundType : null
    this.hits = data ? clone(data.hits) : null
}

PlayerRound.prototype.equals = function (otherPR) {
    return (
        this.playerId === otherPR.playerId &&
        this.roundType === otherPR.roundType
    )
}

PlayerRound.prototype.isNull = function () {
    return this.playerId === null || this.round === null
}

// We can update things even if they aren't a strict match
PlayerRound.prototype.isLiveish = function isLiveish(otherPr) {
    return (
        // Strictly equal
        this.equals(otherPr) ||
        // All batters, this round
        (this.playerId === -1 && this.roundType === otherPr.roundType) ||
        // All batters, all
        (this.playerId === -1 && this.roundType === 'All Rounds') ||
        // Same batter,  all
        (this.playerId === otherPr.playerId && this.roundType === 'All Rounds')
    )
}

util.createPlayerRound = function (roundData) {
    return new PlayerRound(roundData)
}

export default util
